import { makeStyles } from "@material-ui/core/styles";
import { GroupLabel } from "components/front/mypage/layout/GroupLabel";
import { CourseServiceType } from "interfaces/front/business";
import { OrderSummary } from "interfaces/front/OrderListOutput";
import React, { FC, useMemo } from "react";
import OrderItemArea from "./OrderItemArea";

export const GroupedOrderListArea: FC<{
  orderSummaries: OrderSummary[];
  serviceType: CourseServiceType;
  label: string;
  isShopping?: boolean;
  onSelectItem: (orderCode: string) => void;
}> = ({ orderSummaries, serviceType, label, isShopping, onSelectItem }) => {
  const classes = useStyles();
  const orderList = useMemo(() => orderSummaries.filter((it) => it.project.service_type === serviceType), []);
  return orderList.length > 0 ? (
    <div className={classes.root}>
      <GroupLabel className={classes.label}>{label}</GroupLabel>
      {orderList.map((orderSummary, index) => (
        <OrderItemArea key={index} orderSummary={orderSummary} isShopping={isShopping} onClick={() => onSelectItem(orderSummary.order.code)} />
      ))}
    </div>
  ) : (
    <></>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: "30px",
  },
  label: {
    marginBottom: "10px",
  },
}));
